import React from 'react';
import { LazyImageLoader } from '../../product_detail/components/LazyImageLoader';
import { sizeImage } from '../../util';
import styles from './CollectionHeader.module.scss';

interface Props {
  title: string;
  description?: string;
  images?: string[];
}

export const CollectionHeader: React.FC<Props> = ({ title, description, images, children }) => {
  return (
    <div className={styles.collectionHeader}>
      <h2>{title}</h2>
      {children}
      <div className={styles.description}>{description ?? ''}</div>
      {images && (
        <div className={styles.hoverGrid}>
          {images.map((image, index) => (
            <LazyImageLoader key={index} src={sizeImage(image, '350x')} alt={`${title}`} style={{ width: '100%' }} />
          ))}
        </div>
      )}
    </div>
  );
};

export default CollectionHeader;
